import { Box, IconButton, TextInputNew as TextInput, TextInputNewProps } from '@jfs/ui-new'
import { useState, useCallback } from 'react';

interface SearchBarProps {
  onSearchClick: any
}

export const SearchBar = ({ onSearchClick }: SearchBarProps) => {
  const [text, setText] = useState('')

  const onTextChange = useCallback((text: any) => {
    const re = /^[0-9\b]+$/
    if (text === '' || re.test(text)) {
      setText(text)
    }
  }, [])
  return (
    <Box marginHorizontal={16}>
      <TextInput
        {...styles.container}
        rightComponent={<IconButton onPress={() => onSearchClick(text)} id="SEARCH" color="SECONDARY_GREY" size={14} />}
        value={text}
        onChange={onTextChange}
        placeholder={'Search transactions'}
      />
    </Box>
  )
}

const styles = {
  container: {
    flexDirection: 'row',
    borderWidth: 1,
    justifyContent: 'center',
    width: '100%',
    borderColor: 'ITEM_SEPARATOR',
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 16,
    fontSize: 12,
    fontFamily: 'jioType-medium',
    color: 'SECONDARY_GREY',
    placeholderTextColor: 'SECONDARY_GREY',
  } as TextInputNewProps,
}
